/**
 * TerminologyGlobal.tsx
 * Global Terminology Hub - Uses useGlossaryStore for global SynonymGroups management.
 * This is the main view when clicking "Terminology" in the Sidebar.
 */
import React, { useEffect } from 'react';
import { BookOpen, Star } from 'lucide-react';
import { useGlossaryStore } from '../store/useGlossaryStore';
import TerminologyTab from './TerminologyTab';

const TerminologyGlobal: React.FC = () => {
    const { synonymGroups, isLoaded, loadGlossary, setGroups } = useGlossaryStore();

    // Load glossary on mount
    useEffect(() => {
        if (!isLoaded) {
            loadGlossary();
        }
    }, [isLoaded, loadGlossary]);

    return (
        <div className="h-full flex flex-col bg-slate-50/50">
            {/* Page Header */}
            <div className="px-10 py-6 bg-white border-b border-slate-200 shrink-0">
                <div className="max-w-7xl mx-auto flex items-center justify-between">
                    <div>
                        <div className="flex items-center gap-2 mb-1">
                            <Star className="w-4 h-4 text-emerald-500 fill-emerald-500" />
                            <span className="text-[10px] font-black text-emerald-600 uppercase tracking-widest">Tài nguyên dùng chung</span>
                        </div>
                        <h2 className="text-2xl font-black text-slate-800 tracking-tight">Từ điển thuật ngữ</h2>
                        <p className="text-slate-500 font-medium text-sm mt-1">
                            {synonymGroups.length} thuật ngữ áp dụng cho mọi dự án.
                        </p>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="px-4 py-2 bg-emerald-50 text-emerald-700 rounded-xl flex items-center gap-2">
                            <BookOpen className="w-4 h-4" />
                            <span className="text-sm font-bold">{synonymGroups.length} thuật ngữ</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content - Reuse TerminologyTab */}
            <div className="flex-1 overflow-hidden p-6">
                <div className="h-full max-w-7xl mx-auto">
                    <TerminologyTab
                        synonymGroups={synonymGroups}
                        onUpdateSynonymGroups={setGroups}
                    />
                </div>
            </div>
        </div>
    );
};

export default TerminologyGlobal;
